import Model from "./Model";

export default class extends Model{

    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(client => {
                let telem = {
                    tbody: {}
                };
                telem.id = client.id;
                telem.tbody.name = client.name;
                telem.tbody.comment = client.comment;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
